export type Country = Readonly<{ id: number; name: string }>;

export function isCountryCatalog(
  value: unknown,
): value is { schemaVersion: 1; countries: readonly Country[] } {
  if (typeof value !== 'object' || value === null) return false;
  const candidate = value as { schemaVersion?: unknown; countries?: unknown };
  return (
    candidate.schemaVersion === 1 &&
    Array.isArray(candidate.countries) &&
    candidate.countries.length === 267 &&
    candidate.countries.every(
      (country: unknown) =>
        typeof country === 'object' &&
        country !== null &&
        Number.isInteger((country as { id?: unknown }).id) &&
        typeof (country as { name?: unknown }).name === 'string',
    )
  );
}
